<template>
    <div class="page monthPage" style="max-height: 100dvh; max-height: 100vh;">
        <my-scroll scroll-state  ref="myScroll" :page="page" :on-pull="onPull">
            <div slot="scrollList">
                <div class="public-head">
                    <Head></Head>
                    <div class="big-baikuang">
                        <p>{{title}}</p>
                        <span>{{total}}</span>
                    </div>
                </div>
                <div class="public-body">
                    <div class= "Profile-month">
                        <div class="list-box" :class="item.displayStatus" v-for="item in searchList" @click="detail(item)">
                            <p v-if="item.displayStatus==='Stored' || item.displayStatus==='Returns'">{{$t('searchResult.TimeStored')}}: {{item.timeStored ? dateFormat(item.timeStored) : "-"}}<br></p>
                            <p v-if="item.displayStatus==='Collected'">{{$t('searchResult.TimeCollected')}}: {{item.timeCollected ? dateFormat(item.timeCollected) : "-"}}<br></p>
                            <p v-if="item.displayStatus==='ExpiredReturned' || item.displayStatus==='Returned'">{{$t('searchResult.TimeReturned')}}: {{item.timeCollected ? dateFormat(item.timeCollected) : "-"}}<br></p>
                            <p v-if="item.displayStatus==='Recreated'">{{$t('searchResult.Recreated')}}: {{item.timeCreated ? dateFormat(item.timeCreated) : "-"}}<br></p>
                            <span class="express-number">{{item.orderNumber}}</span>
                            <div class="index-body-div">
                                <div>
                                    {{$t(item.displayStatus)}}
                                </div>
                                <font class="Exp" :class="$i18n.locale" v-if="item.overdueFlag && item.displayStatus === 'Stored'">
                                    {{$t('Exp')}}
                                </font>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </my-scroll>
        <div class="Profile-back" @click="back()">
            {{$t('common.Back')}}
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from '../Bottom.vue'
import MyScroll from '../MyScroll.vue'
import Head from './Head'
export default {
  name: 'Month',
  components: {bottom, MyScroll, Head},
  data () {
    return {
      searchList: [],
      total: 0,
      title: null,
      locationName: localStorage.getItem('locationName'),
      page: {
        total: 0
      },
      param: null
    }
  },
  created () {
    // 初始化注入&校验时请求页面数据
    let time = this.getTime()
    // 转换标题时间
    this.title = this.titleFormat(time)
    const vue = this
    vue.param = {
      timeStoredStart: time.begin,
      timeStoredEnd: time.end,
      page: 0,
      size: 10,
      sort: 'lastUpdatedTime,desc'
    }
    this.getData()
  },
  methods: {
    getData () {
      let vue = this
      this.axios({
        method: 'get',
        url: this.api.queryOrders,
        params: vue.param
      }).then(function (response) {
        vue.pushData(response.data.content)
        vue.total = response.data ? response.data.totalElements : 0
        vue.page.total = response.data.totalPages
      }).catch(function (error) {
        console.log(error)
      })
    },
    pushData (data = null) {
      for (let i = 0; i < data.length; i++) {
        if (data[i]['displayStatus'] === 'Expired returned') {
          data[i]['displayStatus'] = 'ExpiredReturned'
        }
        this.searchList.push(data[i])
      }
    },
    onPull () {
      const vue = this
      if (this.param.page < this.page.total) {
        setTimeout(() => {
          this.param.page++
          // 加载完成
          this.$refs.myScroll.setState(5)
          vue.getData(vue.param)
        }, 500)
      } else {
        // 没有数据了
        this.$refs.myScroll.setState(7)
      }
    },
    back () {
      this.$router.back()
    },
    getMonthBeginEnd (year, month) {
      if (~~year === 0 || ~~month === 0) {
        throw new Error('年月参数错误')
      }
      const result = {begin: 0, end: 0}
      const target = new Date()
      target.setFullYear(year)
      target.setMonth(month - 1)
      target.setDate(1)
      target.setHours(0)
      target.setMinutes(0)
      target.setSeconds(0)
      target.setMilliseconds(0)
      result.begin = target.getTime()

      const now = new Date()
      if (target.getFullYear() + target.getMonth() >= now.getFullYear() + now.getMonth()) {
        result.end = now.getTime()
        return result
      }

      target.setMonth(month)// 当月的下个月1日 0时0分0秒
      target.setSeconds(-1)// 前1秒,即昨天最后1秒钟,也就是上个月的最后一秒钟
      result.end = target.getTime()
      return result
    },
    dateFormat (time) {
      let monthArr = this.$t('common.monthArr')
      time = new Date(time)
      let m = monthArr[time.getMonth()] // + this.$t('common.space')
      let d = time.getDate() + this.$t('common.dayFormat') + this.$t('common.space')
      let h = time.getHours()
      if (h.toString().length === 1) {
        h = '0' + h
      }
      let mm = time.getMinutes()
      if (mm.toString().length === 1) {
        mm = '0' + mm
      }
      let dateStr = d + m + ', ' + h + ':' + mm
      return dateStr
    },
    getTime () {
      let monthStr = this.$route.query.monthStr
      let time = null
      if (monthStr) {
        let sub = monthStr.indexOf('-')
        let year = monthStr.substr(0, sub)
        let month = monthStr.substr(sub + 1)
        month = parseInt(month)
        time = this.getMonthBeginEnd(year, month)
      } else {
        let data = new Date()
        let year = data.getFullYear()
        let month = data.getMonth() + 1
        time = this.getMonthBeginEnd(year, month)
      }
      return time
    },
    titleFormat (time) {
      let monthArr = this.$t('common.monthArr')
      time = new Date(time.begin)
      let m = monthArr[time.getMonth()]
      let y = time.getFullYear()
      return m + ' ' + y
    },
    detail (item) {
      let id = item.articleId
      let logisticsId = item.deliverMerchantId
      this.$router.push('/order/details?order=' + id + '&logisticsId=' + logisticsId)
    }
  }
}
</script>

<style src="../../assets/css/bootstrap.css" scoped>
</style>
<style scoped>
    .express-number{
        margin-top: 0.1rem;
        top: -0.1rem;
        overflow-wrap: break-word;
        margin-right: 20px;
    }
    .list-box{
        position:relative;
        height: auto !important;
    }
    .Exp{
        position: absolute;
        bottom: 0.10rem;
        left: 2.15rem;
        height: 0.2rem;
        line-height: 0.2rem;
        font-size: 0.125rem;
        float: right;
    }
    .Exp.br{
      left: 1.88rem;
    }
    .Profile-month{
        width: 93.33%;
        height: auto;
        /*min-height: 5.53rem;*/
        margin-top: 0.23rem !important;
        /* background-color: #000000; */
        margin: auto;
        /*overflow:hidden*/
        margin-bottom: 0.1rem;
    }
    .Returns{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden
    }
    .Profile-month p{
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.145rem;
        color:rgba(172,172,172,1);
        margin-top: 0.135rem !important;
        /*margin-left: 6.14% !important;*/
        text-align: left;
        position: relative;
        left: 0rem;
    }
    .Profile-month span{
        display: block;
        text-align: left;
        margin-left: 6.14%;
        font-size:0.15rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.18rem;
        color:rgba(0,0,0,1);
        position: relative;
        left: -0.19rem;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .list-box{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius: 0.1rem !important;
        overflow:hidden;
        padding:0;
        margin-left: unset !important;
    }
    .list-box p{
        left: 0.15rem !important;
    }
    .list-box span{
        left: -0.05rem !important;
    }
    .list-box>div>div{
        position: absolute;
        /* top: 500px; */
        text-align: center;
        width: 21.29%;
        height: 0.2rem;
        background:rgba(178,70,154,0.5);
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        color:rgba(255,255,255,1);
        margin-top: -0.10rem;
        margin-left: 2.52rem !important;
        right: 0.1rem !important;
    }
    .Returns>div>div{
        position: absolute;
        /* top: 500px; */
        text-align: center;
        /* width: 21.29%; */
        min-width: 21.29%;
        width: max-content;
        /* padding-left: 5px;
        padding-right: 5px; */
        height: 0.2rem;
        /* background:rgba(178,70,154,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        margin-left: 2.52rem;
        background: #E6E6E6;
        color: var(--primary-text-color);
    }
    .Arriving{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden;
        padding:0;
    }
    .Arriving>div>div{
        position: absolute;
        /* top: 500px; */
        text-align: center;
        width: 21.29%;
        height: 0.2rem;
        /* background:rgba(5,36,96,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        /* margin-left: 2.52rem; */
        right: 0.1rem;
        background: #E6E6E6;
        color: var(--primary-text-color);
    }
    .Collected{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden;
        padding:0;
    }
    .Collected>div>div{
        position: absolute;
        /* top: 500px; */
        text-align: center;
        width: 21.29%;
        height: 0.2rem;
        /* background:rgba(0,172,78,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        /* margin-left: 2.52rem; */
        right: 0.1rem;
        background: #E8FCEE;
        color: var(--primary-text-color);
    }
    .Stored{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden;
        padding:0;
    }
    .Stored>div>div{
        position: absolute;
        text-align: center;
        /* top: 500px; */
        width: 21.29%;
        height: 0.2rem;
        /* background:rgba(31,141,197,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        margin-left: 2.52rem;
        background: #E8FCEE;
        color: var(--primary-text-color);
    }
    .Created{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden;
        padding:0;
    }
    .Created>div>div{
        position: absolute;
        text-align: center;
        /* top: 500px; */
        width: 21.29%;
        height: 0.2rem;
        /* background: #E2A148; */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        margin-left: 2.52rem;
        background: #E8FCEE;
        color: var(--primary-text-color);
    }
    .Returned{
        width: 100%;
        /* height: 0.63rem; */
        min-height: 0.63rem;
        height: auto;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden;
        padding:0;
    }
    .Returned>div>div{
        position: absolute;
        text-align: center;
        /* top: 500px; */
        width: 21.29%;
        height: 0.2rem;
        /* background:rgba(31,141,197,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        /* margin-left: 2.52rem; */
        right: 0.1rem;
        background: #E8FCEE;
        color: var(--primary-text-color);
    }
    .Profile-back{
        text-align: center;
        position: fixed;
        width: 82.4%;
        height: 0.58rem;
        bottom: 1.5rem;
        /* margin-left: 8.8%; */
        /* margin-top: 0.33rem !important; */
        box-shadow:0px 10px 20px rgba(0,0,0,0.16);
        border-radius:84px;
        background-color: #FFFFFF;
        /* color: #052460; */
        color: var(--primary-inverted-button-text-color);
        font-size:0.2rem;
        /*font-weight:bold;*/
        font-family: Poppins-Bold;
        line-height:0.58rem;
        margin-bottom: 0.19rem !important;
        max-width: 400px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }
    .public-body{
        min-height: calc(64vh) !important;
        padding-bottom: 200px;
    }
    .my-scroll{
        margin-bottom: 1rem;
    }
    .Profile-back{
        bottom: 0.3rem;
    }
    .Expired.returned div{
        /* background: rgba(172,172,172,0.5) !important; */
        background: #E6E6E6 !important;
        width: 38% !important;
        color: var(--primary-text-color) !important;
    }
    .ExpiredReturned div div{
        /* background: rgba(172,172,172,0.5) !important; */
        background: #E6E6E6 !important;
        /*width: 38% !important;*/
        color: var(--primary-text-color) !important;
    }
    .index-body-div{
        right: -0.2rem;
        top: 20px;
        margin-top: 0;
    }
</style>
<style global>
      .app_body:has(> #app > .monthPage) {
      max-height: 100dvh;
      max-height: 100vh;
      overflow-y: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/Acount/Month.vue